import { Flex, Text } from '@chakra-ui/react'
import { HeaderCard } from '../HeaderCard'

export function Card({
  cnpj,
  uf,
  razaosocial,
  title,
  endereco,
  ie,
  cep,
  cidade,
  nome,
  email,
  cel,
  tel,
  prazo,
  valor,
}) {
  return (
    <>
      <Flex flexDir="column" border="2px solid #cecece">
        <HeaderCard title={title} isGreen />
        <Flex
          flexDir="column"
          ml="1rem"
          fontSize="0.9375rem"
          paddingBlock="1rem"
          gap={1}
        >
          <Text as="span" fontWeight="bold">
            Razão Social:{' '}
            <Text as="span" fontWeight="normal">
              {razaosocial}
            </Text>
          </Text>
          {prazo && (
            <Text as="span" fontWeight="bold">
              Prazo:{' '}
              <Text as="span" fontWeight="normal">
                {prazo} {prazo > 1 ? 'dias úteis' : 'dia útil'}
              </Text>
            </Text>
          )}
          {valor && (
            <Text as="span" fontWeight="bold">
              Valor:{' '}
              <Text as="span" fontWeight="normal">
                {valor}
              </Text>
            </Text>
          )}

          {cnpj && (
            <Text as="span" fontWeight="bold">
              CNPJ:{' '}
              <Text as="span" fontWeight="normal">
                {cnpj}
              </Text>
            </Text>
          )}
          {ie && (
            <Text as="span" fontWeight="bold">
              IE:{' '}
              <Text as="span" fontWeight="normal">
                {ie}
              </Text>
            </Text>
          )}
          {endereco && (
            <Text as="span" fontWeight="bold">
              Endereço:{' '}
              <Text as="span" fontWeight="normal">
                {endereco}
              </Text>
            </Text>
          )}
          {cep && (
            <Text as="span" fontWeight="bold">
              CEP:{' '}
              <Text as="span" fontWeight="normal">
                {cep}
              </Text>
            </Text>
          )}
          {cidade && (
            <Text as="span" fontWeight="bold">
              CIDADE/UF:{' '}
              <Text as="span" fontWeight="normal">
                {cidade} - {uf}
              </Text>
            </Text>
          )}
          {nome && (
            <Text as="span" fontWeight="bold">
              Nome:{' '}
              <Text as="span" fontWeight="normal">
                {nome}
              </Text>
            </Text>
          )}
          {email && (
            <Text as="span" fontWeight="bold">
              Email:{' '}
              <Text as="span" fontWeight="normal">
                {email}
              </Text>
            </Text>
          )}
          {cel && (
            <Text as="span" fontWeight="bold">
              Celular:{' '}
              <Text as="span" fontWeight="normal">
                {cel}
              </Text>
            </Text>
          )}
          {tel && (
            <Text as="span" fontWeight="bold">
              Telefone:{' '}
              <Text as="span" fontWeight="normal">
                {tel}
              </Text>
            </Text>
          )}
        </Flex>
      </Flex>
    </>
  )
}
